import React, { useContext, useEffect, useState } from 'react'
import Header from '../../Components/Header'
import { Link, useNavigate, useParams } from 'react-router-dom'
import MapContext from '../../Components/MapContext';
import toast from 'react-simple-toasts';
import axios from 'axios';
import BaseUrl from '../../BaseUrl';


const EditNotification = () => {


    const navigate = useNavigate()
    const {id}=useParams()






    const [title, setTitle] = useState(null)
    const [body, setBody] = useState(null)





    

    const [data, setData] = useState({})


    useEffect(() => {
        try {

            axios.get(`${BaseUrl.baseUrl}/notification/get/${id}`).then(res => {
                if (res.data.status === 'ok') {
                    setData(res.data.data)
                    setTitle(res.data.data.title)
                    setBody(res.data.data.body)
                }
                else if (res.data.status === 'fail') {
                    toast('🚩' + res.data.message)
                }

            }).catch(err => {
                toast('🚨' + err.message)
            })


        } catch (err) {
            toast('🚨 Something went wrong!')
        }

    }, [])









    const submit = () => {
        if (!title) {
            toast('🚨 Must enter title!')
        }
        else if (!body) {
            toast('🚨 Must enter body!')
        }
        else {

            try {
                const param = {
                    title: title,
                    body: body,
                }


                axios.put(`${BaseUrl.baseUrl}/notification/update/${id}`, param).then(res => {
                    if (res.data.status === 'ok') {
                        toast('🎉 Updated Successfully!')
                        navigate(-1)
                    }
                    else if (res.data.status === 'fail') {
                        toast('🚩' + res.data.message)
                    }

                }).catch(err => {
                    toast('🚨' + err.message)
                })


            } catch (err) {
                toast('🚨 Something went wrong!')
            }

        }

    }



    return (
        <div id="content" className="app-content ms-0">
            <div className="d-flex align-items-center mb-3">
                <div>
                    <ul className="breadcrumb">
                        <li className="breadcrumb-item">
                            <Link to="#">Pages</Link>
                        </li>
                        <li className="breadcrumb-item active">Notification</li>
                    </ul>
                    <h1 className="page-header mb-0">Notification</h1>
                </div>
                <div className="ms-auto">
                    <Link to="/notification" className="btn btn-theme fs-13px fw-semibold ">
                        Show Notification
                    </Link>
                </div>
            </div>
            <div className="row gx-4">
                <div className="col-xl-12">
                    <div className="card mb-4">
                        <div className="card-body">
                            <div className="response-message" />
                            <div >
                                <div className="mb-2 mt-3">
                                    <label htmlFor="">Title</label>
                                    <br />
                                    <input
                                        type="text"
                                        name="title"
                                        placeholder="Title"
                                        className="form-control"
                                        required=""
                                        defaultValue={title}
                                        onChange={(e) => { setTitle(e.target.value) }}
                                    />
                                </div>
                                <div className="mb-2 mt-3">
                                    <label htmlFor="">Body</label> <br />
                                    <textarea
                                        type="text"
                                        name="body"
                                        placeholder="Body"
                                        className="form-control"
                                        required=""
                                        defaultValue={body}
                                        onChange={(e) => { setBody(e.target.value) }}
                                    />
                                </div>
                                <div className="mb-2 mt-2" style={{ float: "inline-end" }}>
                                    <button type="submit" className="btn btn-theme" onClick={submit}>
                                        Edit Notification
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

    )
}

export default EditNotification